import { render, staticRenderFns } from "./player-box.vue?vue&type=template&id=25633d4c&scoped=true&"
import script from "./player-box.vue?vue&type=script&lang=js&"
export * from "./player-box.vue?vue&type=script&lang=js&"
import style0 from "./player-box.vue?vue&type=style&index=0&id=25633d4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25633d4c",
  null
  
)

export default component.exports